// src/pages/LoginPage.js
import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
// import Captcha from '../components/Captcha';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  // const [captchaCompleted, setCaptchaCompleted] = useState(false);
  // const [captchaError, setCaptchaError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    // if (!captchaCompleted) {
    //   setError('Please complete the security verification first.');
    //   return;
    // }

    setIsLoading(true);
    setError(null);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/home');
    } catch (err) {
      setError(err.message);
      // Reset CAPTCHA on login failure for security
      // setCaptchaCompleted(false);
    } finally {
      setIsLoading(false);
    }
  };

  // const handleCaptchaComplete = (isCorrect) => {
  //   setCaptchaCompleted(isCorrect);
  //   if (isCorrect) {
  //     setCaptchaError(null);
  //   }
  // };

  // const handleCaptchaError = (isCorrect) => {
  //   if (!isCorrect) {
  //     setCaptchaError('CAPTCHA verification failed. Please try again.');
  //     setCaptchaCompleted(false);
  //   }
  // };

  return (
    <div className="login-container">
      <h2>Login</h2>
      {error && <p className="error">{error}</p>}
      {/* {captchaError && <p className="error">{captchaError}</p>} */}

      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={isLoading}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={isLoading}
        />

        {/*
        <Captcha
          onCaptchaChange={handleCaptchaComplete}
          isVerified={captchaCompleted}
          onAttempt={handleCaptchaError}
        />
        */}

        <button
          type="submit"
          disabled={isLoading}
        >
          {isLoading ? 'Logging in...' : 'Login'}
        </button>
      </form>
    </div>
  );
}

export default LoginPage;
